import { render, staticRenderFns } from "./TabSwitch.vue?vue&type=template&id=359cb00b&"
import script from "./TabSwitch.vue?vue&type=script&lang=js&"
export * from "./TabSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports